<template>
  <HomeAdminButtonSkeletonLoader v-if="loading" />
  <v-btn
    v-else
    elevation="0"
    :variant="!hovered ? 'outlined' : 'elevated'"
    :color="buttonColor"
    class="home-admin-button"
    rounded
    @click="$emit('updateAdminView', !isAdminOn)"
    @mouseenter="hovered = true"
    @mouseleave="hovered = false"
  >
    <DpplSvg
      v-if="isAdminOn"
      file-name="admin-icon"
      class="mr-2 admin"
    />
    Admin View {{ isAdminOn ? '' : 'Off' }}
    <DpplSvg
      v-if="!isAdminOn"
      file-name="admin-icon"
      class="ml-2"
    />
  </v-btn>
</template>

<script setup>
import { ref, computed } from 'vue';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import HomeAdminButtonSkeletonLoader from '@/components/home/HomeAdminButton/HomeAdminButtonSkeletonLoader.vue';
import { useColors } from '@/composables/colors';

const props = defineProps({
  isAdminOn: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['updateAdminView']);

const { brandPrimary, textDarkest } = useColors();

const hovered = ref(false);

const buttonColor = computed(() => {
  if (props.isAdminOn) {
    return brandPrimary.value;
  }

  return textDarkest.value;
});
</script>

<style lang="less" scoped>
.home-admin-button {
  text-transform: none;
  padding: 8px !important;
  font-size: 12px;
  font-weight: 700;
  margin-top: 55px;
  box-shadow: none !important;

  :deep(svg) path {
    fill: @icon-darkest;
  }

  :deep(svg).admin path {
    fill: @icon-brand;
  }

  &:hover {
    color: @white !important;
    background: v-bind(buttonColor);

    :deep(svg) path {
      fill: @white !important;
    }

  }

}
</style>
